export default "__VITE_ASSET__8_nc6UQ6__"